import React from 'react'
import styled from 'styled-components'
import { TiArrowRightThick } from 'react-icons/ti'
import { Box, Flex, Text, Button } from '@chakra-ui/react'
import { RightArrowSvg } from '../../assets/svgs'

export const StyledCommonButton = styled(Button)`
  .chakra-button__icon {
    margin-inline-start: 14px;
  }
`

const CommonButton = ({ children, iconColor, color, background, ...rest }) => {
  return (
    <Button
      as={StyledCommonButton}
      rightIcon={
        <RightArrowSvg
          boxSize={{ base: 7, lg: 6, xl: 7 }}
          color={iconColor || 'white'}
        />
      }
      fontSize={['14px', '16px', '18px', '20px']}
      lineHeight="1"
      fontWeight="bold"
      letterSpacing="-0.427179px"
      color={color ? color : '#FFFFFF'}
      background={background ? background : '#83B53C'}
      variant="solid"
      padding={[
        '32px 12px 32px 24px',
        '24px 12px 24px 24px',
        '24px 12px 24px 24px',
        '32px 24px 32px 18px',
      ]}
      outline="none !important"
      boxShadow="none"
      borderRadius="0px 18px 0px 0px"
      _hover={{ background: background ? background : '#83B53C' }}
      _focus={{ boxShadow: 'none' }}
      {...rest}
    >
      {children}
    </Button>
  )
}

export default CommonButton
